<template>
  <label :class="context.classes.label" :for="context.id" v-html="context.label" />
</template>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
  },
};
</script>
